module.exports = __webpack_public_path__ + "static/system-extensibility-@2x-13597763bf60bcdc10984c64858322f5.jpg";